export const opportunityRanks = [
    'Very High',
    'High',
    'Moderate',
    'Low',
    'Very Low',
    'Unknown'
];
//# sourceMappingURL=opportunityRanks.js.map